/**
 * 登录时 手机号验证
 * @author lianghua.fu
 * @date 2022-10-12 11:30:16
 */

import styled from 'styled-components';
import S from './styled';
import { Button } from 'client/widgets/ui';
import { OneLogin, ToggleLogin } from './common';
import { observer } from 'mobx-react';
import { useStore } from './store';
import { useBoolean, useNumber, useSetState, useStateful } from 'react-hanger';
import { geetest, hooks, request, user, storage } from 'lib';
import assign from 'lodash/assign';
import { UiModal, UiToast } from 'components';
import { getGlobalStore } from 'stores';
import { useEffect } from 'react';

const { Form, FormTip, FormItem, Input } = S;

const StyledForm = styled(Form)`
  width: auto;
  padding-top: 10px;
`;

const Modal = styled(UiModal)``;

const BtnSend = styled(Button)`
  margin-left: 12px;
  //width: 124px;
  padding-left: 0;
  padding-right: 0;
  font-size: var(--fs-md) !important;
`;

const InputCode = styled(Input)`
  width: 100px;
`;

const cacheKey = 'QT_MOBILE';

//{
//     "access_token": "a43d60ef53db0ad23d6a1d9946a2e3ef",
//     "expires_in": 6000000,
//     "refresh_token": "74eff72bc1c5a8a7a38a318c04fc9ead",
//     "security_checks": false,
//     "en_mobile": "15558005808"
// }
const MobileCheck = observer((props) => {
  const { mobile = '', onSuccess, onClose, loginRes } = props;
  const seconds = useNumber(0);
  const tip = useStateful('');

  const isLoading = useBoolean(false);
  const { state, setState, resetState } = useSetState({
    mobile,
    sms_code: '',
  });

  const onChange = (e) => {
    let { name, value } = e.currentTarget;

    if (name === 'mobile') {
      value = value.replace(/\D/g, '');
    }

    setState({
      [name]: value.replace(/[\u4e00-\u9fa5]|\s/g, ''),
    });
  };

  const checkData = () => {
    if (state.sms_code.length === 0) {
      tip.setValue('请填写验证码');
      return false;
    }

    tip.setValue('');
    return true;
  };

  hooks.useInterval(
    () => {
      seconds.decrease();
    },
    seconds.value > 0 ? 1000 : null,
  );

  const onSendCode = (e) => {
    e.preventDefault();

    geetest(
      'quick_login_check',
      (geetestData, captchaObj) => {
        // let isChina = currentCountry.value.country === '中国';
        let data = {
          mobile: state.mobile,
          nation_code: '+86',
        };
        data = assign(data, geetestData);
        captchaObj.reset();

        request.amber
          .post({
            url: 'api/v2/verify_code/quick_login',
            contentType: 'JSON',
            data,
            trackOpt: {
              event: 'userLogin',
              event_type: 'verify_code',
            },
          })
          .then(() => {
            seconds.setValue(60);
            UiToast.success('验证码发送成功');
          })
          .catch((res) => {
            tip.setValue(res.msg || '验证码发送失败');
          });
      },
      () => {
        tip.setValue('校验异常');
      },
      () => {},
    );
  };

  const onLogin = (e) => {
    if (isDisableSubmit) {
      return;
    }
    e.preventDefault();

    if (checkData() && !isLoading.value) {
      isLoading.setTrue();
      user.loginMobileCheck({
        ...state,
        loginRes,
        onSuccess: () => {
          isLoading.setFalse();
          onClose();
          return onSuccess();
        },
        onFail: (msg) => {
          tip.setValue(msg);
          isLoading.setFalse();
        },
      });
    }
  };

  const isDisableSubmit =
    state.mobile.length === 0 || state.sms_code.length === 0;
  return (
    <Modal
      title={'验证手机号'}
      isShowFooter={false}
      onClose={onClose}
      className="_dark"
    >
      <StyledForm show>
        <FormItem>
          <span>
            发送验证码到手机号：
            {state.mobile.replace(/(\d{3})(\d{4})(\d{4})/, '$1 **** $3')}
          </span>
        </FormItem>
        <FormItem>
          <InputCode
            placeholder="请输入验证码"
            name="sms_code"
            maxLength={6}
            value={state.sms_code}
            onChange={onChange}
          ></InputCode>
          {seconds.value > 0 ? (
            <BtnSend type="primary" round size={'lg'} disable>
              {seconds.value}秒后重新获取
            </BtnSend>
          ) : (
            <BtnSend
              type="primary"
              round
              size={'lg'}
              disable={state.mobile.length === 0}
              onClick={onSendCode}
            >
              发送验证码
            </BtnSend>
          )}
        </FormItem>
        <FormTip>{tip.value}</FormTip>
        <FormItem>
          {isLoading.value ? (
            <Button type="primary" size={'lg'} disable round block>
              加载中...
            </Button>
          ) : (
            <Button
              type="primary"
              size={'lg'}
              round
              block
              disable={isDisableSubmit}
              onClick={onLogin}
            >
              确&nbsp;定
            </Button>
          )}
        </FormItem>
      </StyledForm>
    </Modal>
  );
});

export default MobileCheck;
